<div [formGroup]="durationForm">
  <input 
    formControlName="interval_days" 
    id="days" 
    mask="09" 
    matInput 
    placeholder="DD" 
    suffix="d" 
    type="text"
    (input)="onInputChange($event, 'days')"
    (blur)="onInputBlur($event, 'days')" />
  <input 
    formControlName="interval_hours" 
    id="hours" 
    mask="09" 
    matInput 
    placeholder="HH" 
    suffix="h" 
    type="text"
    (input)="onInputChange($event, 'hours')"
    (blur)="onInputBlur($event, 'hours')" />
  <span>:</span>
  <input 
    formControlName="interval_minutes" 
    mask="09" 
    matInput 
    placeholder="MM" 
    suffix="m" 
    type="text"
    (input)="onInputChange($event, 'minutes')"
    (blur)="onInputBlur($event, 'minutes')" />
</div>